import { Class } from '../associates/class.model';
import { Vehicle } from '../vehicle/vehicle.model';
import { QuoteAdditionalCharge } from '../fixed-operations/quote-additional-charge.model';
import { QuoteDetail } from '../fixed-operations/quote-detail.model';
import { WorkOrder } from '../fixed-operations/work-order.model';
import { GstTax } from '../common/gst-tax.model';
import { PstTax } from '../common/pst-tax.model';
import { SubSystemTransactionType } from '../system/sub-system-transaction-type.model';
import { WorkOrderAdditionalCharge } from '../fixed-operations/work-order-additional-charge.model';
import {
  MessageTransactionMessagePreference,
  PartSalesAdditionalCharge,
  PartSalesDetail,
  QuoteSalesAdditionalCharge,
  QuoteSalesDetail,
  VehicleBrakeMeasurement,
  WorkOrderCase,
  WorkOrderLabour,
} from '../fixed-operations';
import { Address, MessageType } from '../associates';
export class VcrData {
  // Lifecycle short-circuit payload from GET public/vcr-data: when either flag
  // is true the server sends only these fields and none of the report data.
  superseded?: boolean;
  supersededByGuid?: string;
  responded?: boolean;
  workOrderId?: number;
  agreementClause: string = null;
  associateClass: Class = null;
  brakeMeasurements: VehicleBrakeMeasurement[] = null;
  caseTotals: any[] = null;
  custId: any = null;
  customer: any = null;
  customerAddress: Address;
  customerAssociateMessagePreferenceInfo: any = null;
  declinedReasons: any[] = null;
  gmMyRewardDetails: any = null;
  gstSettings: GstTax = null;
  inspection: any[] = null;
  inspectionDetails: any = null;
  lastSentVcr: any;
  media: any[] = null;
  messagePreferenceFromTransaction: MessageTransactionMessagePreference[] = null;
  messageTypes: MessageType[] = null;
  partSalesAdditionalCharges: PartSalesAdditionalCharge[] = null;
  partSalesDetails: PartSalesDetail[] = null;
  previouslyAcceptedGMServices: QuoteDetail[] = null;
  pstSettings: PstTax = null;
  quoteAdditionalCharges: QuoteAdditionalCharge[] = null;
  quoteDetails: QuoteDetail[] = null;
  quoteHeaderId: number = null;
  quoteSalesAdditionalCharges: QuoteSalesAdditionalCharge[] = null;
  quoteSalesDetails: QuoteSalesDetail[] = null;
  sct: any = null;
  serviceAdvisor: any = null;
  subSystemTransactionTypes: SubSystemTransactionType = null;
  updateKey: string = null;
  vehicle: Vehicle = null;
  workOrder: WorkOrder = null;
  workOrderAdditionalCharges: WorkOrderAdditionalCharge[] = null;
  workOrderCases: WorkOrderCase[] = null;
  workOrderLabours: WorkOrderLabour[] = null;
  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

export interface VcrTotals {
  subTotal: number;
  shopSupplies: number;
  shopSuppliesTaxable: number;
  tax: number;
}

/**
 * A quote line's parts and additional charges, kept split by tax type. The DMS stamps a quote
 * line's own gst/pst against the whole line, these rows included, so only a tax type it has
 * not stamped books them separately.
 */
export interface QuoteLineCharges {
  subTotal: number;
  gstAmount: number;
  pstAmount: number;
}
